import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    background: {
      default: "#FAFAFA",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#0B0B0B",
      secondary: "#8A8A8A",
    },
    primary: {
      main: "#0B0B0B",
    },
  },

  typography: {
    fontFamily: "Inter, sans-serif",

    h1: {
      fontFamily: "Playfair Display, serif",
      fontWeight: 500,
      fontSize: "clamp(3rem, 6vw, 5.5rem)",
      lineHeight: 1.1,
    },
    h2: {
      fontFamily: "Playfair Display, serif",
      fontWeight: 500,
      fontSize: "clamp(2.5rem, 5vw, 4rem)",
    },
    h3: {
      fontFamily: "Playfair Display, serif",
      fontWeight: 500,
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.7,
    },
    button: {
      textTransform: "none",
      letterSpacing: "0.08em",
    },
  },

  shape: {
    borderRadius: 0,
  },

  transitions: {
    duration: {
      standard: 500,
    },
  },
});

export default theme;
